import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getClientFromUrl } from 'src/app/helpers/utils';

@Injectable()
export class ClientInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add client  header
    const clientFromUrl = getClientFromUrl();
    request = request.clone({
      setHeaders: {
        clientname: clientFromUrl
      }
    });

    return next.handle(request);
  }
}
